import * as angular from "angular";

export class PlanningProjectProcessTrackingRequestsService {

  constructor(private PlanningProjectsProcessTrackingAPI, private $planningProjectsProcessTracking) {
  }


  getProjectProcesses(projectId, status?, processType?) {
    const api = this.PlanningProjectsProcessTrackingAPI.actions.getProcesses;
    return this.call(api, {status:status, processType:processType}, {}, {projectId: projectId});
  }

  getProjectProcess(id) {
    const api = this.PlanningProjectsProcessTrackingAPI.actions.getProcess;
    return this.call(api, {}, {}, {id: id});
  }

  private call(_apiCall, _params, _data, _options) {
    return this.$planningProjectsProcessTracking().$call(_apiCall, _params, _data, _options);
  }

}

angular
  .module('bringoz.admin.planning')
  .service('planningProjectProcessTrackingRequestsService', PlanningProjectProcessTrackingRequestsService);

